import { types } from 'mobx-state-tree';

export const ApplicantBlockModel = types
  .model('ApplicantBlockModel', {
    applicantName: types.maybe(types.string),
    organisationName: types.maybe(types.string),
    phoneNumber: types.maybe(types.string),
    mobilePhoneNumber: types.maybe(types.string),
    email: types.maybe(types.string),
    socialSecurityNumber: types.maybe(types.string),
    organisationNumber: types.maybe(types.string)
  })
  .actions(self => ({
    setValues(changedValues) {
      for (let key in changedValues) {
        self[key] = changedValues[key];
      }
    }
  }));
